import { ErrorModalContext } from 'globalComponents/errors/ErrorModalProvider'
import { useContext } from 'react'

const useErrorModal = () => {
  const context = useContext(ErrorModalContext)
  if (!context) throw new Error('"useErrorModal" must be used within an ErrorModalProvider')
  return context.showErrorModal
}

export default useErrorModal